import { render, staticRenderFns } from "./ContactSupport.vue?vue&type=template&id=0ffb2ff4&scoped=true&"
import script from "./ContactSupport.vue?vue&type=script&lang=js&"
export * from "./ContactSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffb2ff4",
  null
  
)

export default component.exports